import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class ClienteTabPrecoB2BEmpresaValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let assClienteTabPreco = model;

        if (!assClienteTabPreco.idCliente) {
            refs.empresaInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message('alert', 'necessario-cliente', true))
        }
        if (!assClienteTabPreco.idTabPreco) {
            refs.tabPrecoInput.focusedOut = true;
            validated = false;
            this.showMessage(new Message('alert', 'msg-necessario-tab-preco', true))
        }

        return validated;
    }

}